import { React, useEffect } from 'react';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import { Country, State, City } from 'country-state-city';
import { Link } from 'react-router-dom';
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from 'cdbreact';


const CountryList = () => {

    const countryList = Country.getAllCountries();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);

    function testClickEvent(param) {
        alert('Row Click Event');
    }
    // console.log(countryList)

    const data = () => {
        return {
            columns: [
                
                {
                    label: 'Country Name',
                    field: 'name',
                    width: 270,
                },
                {
                    label: 'Currency Code',
                    field: 'currency',
                    width: 200,
                },
                {
                    label: 'ISO Code',
                    field: 'isoCode',
                    sort: 'asc',
                    width: 100,
                },
                {
                    label: 'Phone Code',
                    field: 'phonecode',
                    sort: 'disabled',
                    width: 150,
                },
                {
                    label: 'Lattitude',
                    field: 'latitude',
                    sort: 'disabled',
                    width: 100,
                },
                {
                    label: 'Longitude',
                    field: 'longitude',
                    sort: 'disabled',
                    width: 100,
                },
                 
            ],
            rows: countryList,
        };
    };




    return (
        <>
            <h1 className='text-center'>Country List </h1>
            <MDBTable striped>
                <MDBTableHead>
                    <tr>
                        <th scope='col'>#</th>
                        <th scope='col'>Country Name</th>
                        <th scope='col'>Currency Code</th>
                        <th scope='col'>ISO Code</th>
                        <th scope='col'>Phone Code</th>
                        <th scope='col'>Lattitude</th>
                        <th scope='col'>Longitude</th>
                        <th scope='col'>Link</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    {countryList.map((item, index) => (
                        <tr>

                            <th scope='row'>{index + 1}</th>
                            <td>{item.name}</td>
                            <td>{item.currency}</td>
                            <td>{item.isoCode}</td>
                            <td>{item.phonecode}</td>
                            <td>{item.latitude}</td>
                            <td>{item.longitude}</td>
                            <td><Link to={`/StateList/${item.isoCode}`}>Link</Link></td>
                        </tr>
                    ))}

                </MDBTableBody>
            </MDBTable>
            <CDBContainer>
                <CDBCard>
                    <CDBCardBody>
                        <CDBDataTable
                            striped
                            bordered
                            hover
                            entriesOptions={[5, 20, 25]}
                            entries={10}
                            pagesAmount={4}
                            data={data()}
                            materialSearch={true}
                        />
                    </CDBCardBody>
                </CDBCard>
            </CDBContainer>
        </>
    )
}

export default CountryList